/* ==========================================================================
   prinsert-game-suggest.js
   --------------------------------------------------------------------------
   Ergaenzt Shopifys Sofortsuche um zwei Dinge:

     1. SPIELE-TREFFER PER TEILSTRING
        Shopify sucht mit PRAEFIXEN: "ev" findet "Everdell", aber nicht
        "Revive"; "schlag" findet gar nichts. Die Spieleliste steht als
        JSON im Markup (snippets/header-search.liquid) und wird hier im
        Browser gefiltert -- wie das Suchfeld im Spiele-Menue.

     2. PRODUKTE ZU ALLEN GEFUNDENEN SPIELEN
        Fuer JEDES gefundene Spiel laeuft eine eigene Suchanfrage mit dem
        VOLLEN Namen. Bei "schlag" also drei. Erst mit dem vollen Namen
        greift Shopifys Praefix-Logik, denn Titel und Tags beginnen damit.

   ==========================================================================
   WARUM PRODUKTE KURZ ERSCHIENEN UND WIEDER VERSCHWANDEN (behoben)

   Shopify ersetzt den kompletten Listeninhalt, sobald seine eigene Antwort
   eintrifft. Meine Produktabfragen sind oft schneller -- die Produkte
   standen also schon da und wurden vom nachfolgenden Server-HTML
   ueberschrieben.

   Die erste Fassung setzte im MutationObserver nur die SPIELE neu ein, die
   Produkte nicht. Sie waren damit endgueltig weg.

   JETZT: Beide Ergebnisse werden im Zustand gehalten (zustand.spiele,
   zustand.produkte) und bei jedem Neuaufbau der Liste gemeinsam wieder
   eingesetzt. Der Zustand haengt an der normalisierten Eingabe -- passt er
   nicht mehr zum aktuellen Text, wird er verworfen statt falsch angezeigt.
   ========================================================================== */

(function () {
  if (window.__prinsertGameSuggestInit) return;
  window.__prinsertGameSuggestInit = true;

  var MAX_SPIELE = 4;
  var MAX_PRODUKTE = 12;
  var ENTPRELLEN_MS = 200;

  var produktCache = {};

  function normalize(value) {
    return (value || '')
      .toLowerCase()
      .replace(/\u00df/g, 'ss')
      .replace(/\u00e4/g, 'ae')
      .replace(/\u00f6/g, 'oe')
      .replace(/\u00fc/g, 'ue')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  /* "Fluegelschlag" soll auch bei Eingabe von "flugelschlag" gefunden
     werden -- deshalb zusaetzlich eine Variante ohne das eingefuegte e. */
  function collapseUmlautE(value) {
    return value.replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
  }

  function baueIndex(wrapper) {
    var quelle = wrapper.querySelector('.prinsert-game-index');
    if (!quelle) return [];

    var roh;
    try {
      roh = JSON.parse(quelle.textContent);
    } catch (e) {
      return [];
    }

    return roh.map(function (eintrag) {
      var plain = normalize(eintrag.t);
      return {
        titel: eintrag.t,
        url: eintrag.u,
        heu: [plain, collapseUmlautE(plain)]
      };
    });
  }

  function passt(eintrag, tokens) {
    return tokens.every(function (token) {
      var loose = collapseUmlautE(token);
      return eintrag.heu.some(function (h) {
        return h.indexOf(token) !== -1 || h.indexOf(loose) !== -1;
      });
    });
  }

  /* Baut eine Gruppe im Stil von Dawns eigenen Ergebnisgruppen. */
  function baueGruppe(ueberschrift, extraKlasse) {
    var gruppe = document.createElement('div');
    gruppe.className = 'predictive-search__result-group ' + extraKlasse;

    var innen = document.createElement('div');

    var h = document.createElement('h2');
    h.className = 'predictive-search__heading text-body caption-with-letter-spacing';
    h.textContent = ueberschrift;

    var ul = document.createElement('ul');
    ul.className = 'predictive-search__results-list list-unstyled';
    ul.setAttribute('role', 'group');

    innen.appendChild(h);
    innen.appendChild(ul);
    gruppe.appendChild(innen);

    return { gruppe: gruppe, liste: ul };
  }

  function spielZeile(spiel) {
    var li = document.createElement('li');
    li.className = 'predictive-search__list-item';
    li.setAttribute('role', 'option');
    li.setAttribute('aria-selected', 'false');

    var a = document.createElement('a');
    a.className = 'predictive-search__item link link--text';
    a.href = spiel.url;

    var inhalt = document.createElement('div');
    inhalt.className = 'predictive-search__item-content predictive-search__item-content--centered';

    var titel = document.createElement('p');
    titel.className = 'predictive-search__item-heading h5';
    /* textContent statt String-Verkettung: Namen wie "Darwin's Journey"
       kaemen sonst falsch an. */
    titel.textContent = spiel.titel;

    inhalt.appendChild(titel);
    a.appendChild(inhalt);
    li.appendChild(a);
    return li;
  }

  /* Holt die Produktzeilen zu einem vollen Spielnamen ueber dieselbe
     Sofortsuche-Route, die die Seite ohnehin nutzt. */
  function ladeProdukte(spielname) {
    if (produktCache[spielname]) return Promise.resolve(produktCache[spielname]);

    var url =
      '/search/suggest?q=' +
      encodeURIComponent(spielname) +
      '&resources[type]=product&resources[limit]=10&resources[limit_scope]=each' +
      '&section_id=predictive-search';

    return fetch(url)
      .then(function (r) {
        return r.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var liste = doc.querySelector('#predictive-search-results-products-list');
        var eintraege = liste ? Array.prototype.slice.call(liste.children) : [];
        produktCache[spielname] = eintraege;
        return eintraege;
      })
      .catch(function () {
        return [];
      });
  }

  function hrefVon(li) {
    var a = li.querySelector('a[href]');
    if (!a) return '';
    return (a.getAttribute('href') || '').split('?')[0];
  }

  function setup(wrapper) {
    if (wrapper.__prinsertGameSuggest) return;

    var index = baueIndex(wrapper);
    if (index.length === 0) return;

    var input = wrapper.querySelector('.search__input');
    var liste = wrapper.querySelector('.predictive-search');
    if (!input || !liste) return;

    wrapper.__prinsertGameSuggest = true;

    var entprellTimer = null;

    /* Gehaltener Zustand. Ohne ihn waeren die Produkte nach Shopifys
       naechstem Neuaufbau der Liste verloren -- genau das war der Fehler,
       bei dem sie kurz aufblitzten und wieder verschwanden. */
    var zustand = { frage: '', spiele: [], produkte: [] };

    function aktuelleFrage() {
      return normalize(input.value);
    }

    function trefferFuer(frage) {
      var tokens = frage ? frage.split(/\s+/) : [];
      if (tokens.length === 0) return [];

      return index
        .filter(function (e) {
          return passt(e, tokens);
        })
        .slice(0, MAX_SPIELE);
    }

    /* Setzt Spiele und Produkte aus dem Zustand in die Liste ein. Wird bei
       jedem Neuaufbau erneut aufgerufen. */
    function einsetzen() {
      var frage = aktuelleFrage();

      // Zustand gehoert zu einer aelteren Eingabe? Dann nicht verwenden.
      if (zustand.frage !== frage) {
        zustand = { frage: frage, spiele: trefferFuer(frage), produkte: [] };
      }

      if (!frage || zustand.spiele.length === 0) return;

      var ziel = liste.querySelector('#predictive-search-results');
      if (!ziel) return;

      var w = ziel.querySelector('#predictive-search-results-groups-wrapper');

      // --- Spiele ---
      if (!ziel.querySelector('.prinsert-game-group')) {
        var block = baueGruppe('Spiele', 'prinsert-game-group');
        zustand.spiele.forEach(function (spiel) {
          block.liste.appendChild(spielZeile(spiel));
        });

        if (w) {
          w.insertBefore(block.gruppe, w.firstChild);
        } else {
          ziel.insertBefore(block.gruppe, ziel.firstChild);
        }
      }

      // --- Produkte ---
      if (zustand.produkte.length === 0) return;
      if (ziel.querySelector('.prinsert-product-group')) return;

      var vorhandene = ziel.querySelector('#predictive-search-results-products-list');
      var gesehen = {};

      if (vorhandene) {
        Array.prototype.forEach.call(vorhandene.children, function (li) {
          gesehen[hrefVon(li)] = true;
        });
      }

      var neue = [];
      zustand.produkte.forEach(function (li) {
        var href = hrefVon(li);
        if (!href || gesehen[href]) return;
        gesehen[href] = true;
        neue.push(li.cloneNode(true));
      });

      if (neue.length === 0) return;

      if (vorhandene) {
        var platz = MAX_PRODUKTE - vorhandene.children.length;
        neue.slice(0, Math.max(0, platz)).forEach(function (li) {
          vorhandene.appendChild(li);
        });
        return;
      }

      var pBlock = baueGruppe('Produkte', 'prinsert-product-group');
      neue.slice(0, MAX_PRODUKTE).forEach(function (li) {
        pBlock.liste.appendChild(li);
      });

      var w2 = ziel.querySelector('#predictive-search-results-groups-wrapper') || ziel;
      var spieleGruppe = w2.querySelector('.prinsert-game-group');
      if (spieleGruppe && spieleGruppe.nextSibling) {
        w2.insertBefore(pBlock.gruppe, spieleGruppe.nextSibling);
      } else {
        w2.appendChild(pBlock.gruppe);
      }
    }

    /* Holt die Produkte aller Spieltreffer und legt sie in den Zustand. */
    function holeProdukte() {
      var frage = aktuelleFrage();
      var treffer = trefferFuer(frage);
      if (treffer.length === 0) return;

      Promise.all(
        treffer.map(function (spiel) {
          return ladeProdukte(spiel.titel);
        })
      ).then(function (ergebnisse) {
        // Eingabe hat sich zwischenzeitlich geaendert? Antwort verwerfen.
        if (aktuelleFrage() !== frage) return;

        var alle = [];
        var gesehen = {};
        ergebnisse.forEach(function (eintraege) {
          eintraege.forEach(function (li) {
            var href = hrefVon(li);
            if (!href || gesehen[href]) return;
            gesehen[href] = true;
            alle.push(li);
          });
        });

        zustand = { frage: frage, spiele: treffer, produkte: alle };
        einsetzen();
      });
    }

    /* Shopify ersetzt den Listeninhalt bei jedem Tastendruck komplett.
       Der Beobachter setzt Spiele UND Produkte danach wieder ein. */
    new MutationObserver(function () {
      einsetzen();
    }).observe(liste, { childList: true, subtree: true });

    input.addEventListener('input', function () {
      setTimeout(einsetzen, 30);

      clearTimeout(entprellTimer);
      entprellTimer = setTimeout(holeProdukte, ENTPRELLEN_MS);
    });
  }

  function init() {
    document.querySelectorAll('.header__search--inline').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
